/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

const getToken = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    return session?.access_token;
};

// ─── Renk Paleti ─────────────────────────────────────────────────────────────
const C = {
    bg:      "#0f172a",
    panel:   "#1e293b",
    border:  "#334155",
    text:    "#e2e8f0",
    muted:   "#94a3b8",
    accent:  "#3b82f6",
    success: "#16a34a",
    danger:  "#dc2626",
    warning: "#f59e0b",
    purple:  "#7c3aed",
    teal:    "#0d9488",
};

// ─── Bilgi Kartı İçerikleri ───────────────────────────────────────────────────
const WFO_BILGI = {
    train_basari: {
        baslik: "Train Başarı",
        aciklama: "Parametre kombinasyonu train döneminde (geçmiş veri) kaç sinyali doğru tahmin etti? Bu eğitim verisidir — yüksek çıkması her zaman iyi değil, overfitting (ezberleme) riski taşır.",
    },
    test_basari: {
        baslik: "Test Başarı",
        aciklama: "Aynı parametreler daha önce hiç görmediği test döneminde (out-of-sample) ne kadar başarılı oldu? Bu değer gerçek performansı gösterir. Train'den düşük olması normaldir — aradaki fark küçükse parametreler sağlıklıdır.",
    },
    onceki: {
        baslik: "Önceki",
        aciklama: "Bu modülün bir önceki WFO koşusundaki out-of-sample test başarı oranı. Mevcut koşuyla karşılaştırma yapabilmek için referans olarak gösterilir.",
    },
    delta: {
        baslik: "Δ (Değişim)",
        aciklama: "Test başarısının önceki WFO koşusuna göre değişimi. Yeşil ▲ = iyileşme (parametreler daha iyi bir kombinasyon buldu), Kırmızı ▼ = gerileme. İlk koşunda önceki değer olmadığından — gösterilir.",
    },
    test_sharpe: {
        baslik: "Test Sharpe",
        aciklama: "Test dönemindeki risk-getiri oranı. Her birim risk için ne kadar getiri elde edildiğini ölçer. 1.0+ iyi, 2.0+ çok iyi, negatif = kaybettiriyor. Az sinyal olduğunda güvenilirliği düşer.",
    },
    sinyal: {
        baslik: "Sinyal Sayısı",
        aciklama: "Test döneminde başarı hesabına giren sinyal sayısı. 10'un altında istatistiksel güvenilirlik düşüktür, yorumlamada dikkatli olunmalıdır. Veri birikmesiyle bu sayı artacaktır.",
    },
    deploy: {
        baslik: "Deploy",
        aciklama: "Bu modülün optimize edilmiş parametrelerini production ortamına al. Deploy sonrası tüm taramalar bu parametrelerle çalışır. Birden fazla modülü seçip tek seferde deploy edebilirsin.",
    },
};

function BilgiIkonu({ karti }) {
    const [acik, setAcik] = useState(false);
    const bilgi = WFO_BILGI[karti];
    if (!bilgi) return null;
    return (
        <span
            onMouseEnter={() => setAcik(true)}
            onMouseLeave={() => setAcik(false)}
            style={{
                position: "relative", marginLeft: 5, fontSize: 10, color: C.muted, cursor: "help",
                borderRadius: "50%", border: `1px solid ${C.border}`,
                padding: "0 4px", lineHeight: "16px", display: "inline-block",
                userSelect: "none", verticalAlign: "middle",
            }}>
            ℹ
            {acik && (
                <div style={{
                    position: "absolute", top: "calc(100% + 8px)", left: "50%", transform: "translateX(-50%)",
                    background: C.panel, border: `1px solid ${C.border}`, borderRadius: 8,
                    padding: "10px 12px", width: 260, boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                    zIndex: 999, textAlign: "left", whiteSpace: "normal", fontWeight: 400,
                }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.text, marginBottom: 4 }}>{bilgi.baslik}</div>
                    <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.6 }}>{bilgi.aciklama}</div>
                </div>
            )}
        </span>
    );
}

const MODUL_ETIKETLER = {
    fvg:            "FVG Tarama",
    msb:            "MSB Tarama",
    ote:            "OTE Tarama",
    obbb:           "OB/BB Tarama",
    smt:            "SMT Tarama",
    killzone:       "Killzone Tarama",
    divergence:     "Divergence Tarama",
    capa:           "Çapa Tarama",
    dip:            "Dip Tarama",
    likidite:       "Likidite Tarama",
    inducement:     "IDM Tarama",
    pd:             "P/D Tarama",
    hacim_akisi:    "Hacim Akışı",
    hacim_profili:  "Hacim Profili Tarama",
    islem_planlama: "İşlem Planlama",
    karar_motoru:   "Karar Motoru",
    puanlama:       "Puanlama & Tahmin",
    topdown:        "Topdown Cascade",
    coklu:          "Çoklu Tarama",
    birlesik_skor:  "Birleşik Skor",
};

const basariRenk = (val) => {
    if (val === null || val === undefined) return "#6b7280";
    if (val >= 75) return "#16a34a";
    if (val >= 60) return "#22c55e";
    if (val >= 50) return "#d97706";
    return "#ef4444";
};

const delta = (test, onceki) => {
    if (test === null || onceki === null || test === undefined || onceki === undefined) return null;
    return Math.round((test - onceki) * 10) / 10;
};

const DeltaBadge = ({ val }) => {
    if (val === null || val === undefined) return null;
    const renk  = val > 0 ? "#22c55e" : val < 0 ? "#ef4444" : "#9ca3af";
    const isaret = val > 0 ? "▲" : val < 0 ? "▼" : "–";
    return (
        <span style={{ color: renk, fontSize: 11, marginLeft: 4, fontWeight: 600 }}>
            {isaret}{Math.abs(val).toFixed(1)}%
        </span>
    );
};

export default function WalkForwardOptimizasyon() {
    const [mod,           setMod]           = useState("BIST");
    const [calisiyor,     setCalisiyor]     = useState(false);
    const [ilerleme,      setIlerleme]      = useState(0);
    const [ilerlemeMsg,   setIlerlemeMsg]   = useState("Hazır");
    const [kosunId,       setKosunId]       = useState(null);
    const [sonuclar,      setSonuclar]      = useState(null);      // {kosun, moduller, aktif}
    const [gecmis,        setGecmis]        = useState([]);
    const [seciliKosun,   setSeciliKosun]   = useState(null);
    const [deploySecili,  setDeploySecili]  = useState(new Set());
    const [deploying,     setDeploying]     = useState(false);
    const [aktifParam,    setAktifParam]    = useState({});        // tüm modüller aktif params
    const [detayModul,    setDetayModul]    = useState(null);      // pencere detayı açık modül
    const [yukleniyor,    setYukleniyor]    = useState(false);
    const [gecenSure,      setGecenSure]      = useState(0);
    // ── Rejim WFO state'leri ───────────────────────────────────
    const [sekme,              setSekme]              = useState("genel");
    const [rejimCalisiyor,     setRejimCalisiyor]     = useState(false);
    const [rejimIlerleme,      setRejimIlerleme]      = useState(0);
    const [rejimMsg,           setRejimMsg]           = useState("Hazır");
    const [rejimKosunId,       setRejimKosunId]       = useState(null);
    const [rejimSonuclar,      setRejimSonuclar]      = useState(null);
    const [rejimGecenSure,     setRejimGecenSure]     = useState(0);
    const [deployModal,        setDeployModal]        = useState(false);
    const [deploySeciliRejim,  setDeploySeciliRejim]  = useState(new Set());
    const [deployingRejim,     setDeployingRejim]     = useState(false);
    const [aktifRejim,         setAktifRejim]         = useState(null);
    const [secilenRejimTab,    setSecilenRejimTab]    = useState("Boğa");
    const [rejimGecmis,        setRejimGecmis]        = useState([]);

    const pollRef      = useRef(null);
    const timerRef     = useRef(null);
    const rejimPollRef = useRef(null);
    const rejimTimerRef= useRef(null);

    // ── Polling ────────────────────────────────────────────────
    const clearPollOnly = useCallback(() => {
        if (pollRef.current) { clearInterval(pollRef.current); pollRef.current = null; }
    }, []);

    const stopPoll = useCallback(() => {
        if (pollRef.current)  { clearInterval(pollRef.current);  pollRef.current  = null; }
        if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    }, []);

    const stopRejimPoll = useCallback(() => {
        if (rejimPollRef.current)  { clearInterval(rejimPollRef.current);  rejimPollRef.current  = null; }
        if (rejimTimerRef.current) { clearInterval(rejimTimerRef.current); rejimTimerRef.current = null; }
    }, []);

    const startPoll = useCallback(() => {
        clearPollOnly(); // NOT: burada stopPoll() ÇAĞRILMAZ — aksi halde az önce başlatılan
                          // "geçen süre" zamanlayıcısı (timerRef) da anında silinir ve sayaç
                          // 1-2 saniyede donup kalır. Sadece eski poll interval'ı temizlenir.
        pollRef.current = setInterval(async () => {
            try {
                const token = await getToken();
                const r = await axios.get(`${API_URL}/scan/wfo/durum`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setIlerleme(r.data.yuzde || 0);
                setIlerlemeMsg(r.data.mesaj || "");
                if (!r.data.calisiyor) {
                    stopPoll();
                    setCalisiyor(false);
                    if (r.data.kosun_id) {
                        await sonuclariYukle(r.data.kosun_id);
                        toast.success("WFO tamamlandı!");
                    }
                }
            } catch (e) {
                console.error("WFO polling hatası:", e);
            }
        }, 3000);
    }, [mod, clearPollOnly, stopPoll]);

    useEffect(() => { return () => { stopPoll(); stopRejimPoll(); }; }, [stopPoll, stopRejimPoll]);

    // ── İlk yükleme ────────────────────────────────────────────
    useEffect(() => {
        gecmisYukle();
        aktifParamYukle();
        rejimGecmisYukle();
    }, [mod]);

    const gecmisYukle = async () => {
        try {
            const token = await getToken();
            const r = await axios.get(`${API_URL}/scan/wfo/gecmis?mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const liste = (r.data || []).filter(k => k.mod === mod);
            setGecmis(liste);

            // Devam eden bir koşu var mı? (örn. Pazar gecesi otomatik başlatılan WFO)
            const aktifKosu = liste.find(k => k.durum === "calisiyor");
            if (aktifKosu) {
                setSonuclar(null);
                setSeciliKosun(null);
                setKosunId(aktifKosu.id);
                setCalisiyor(true);
                setIlerlemeMsg(prev => prev || "Devam ediyor...");
                const baslangicMs = aktifKosu.baslatildi_at ? new Date(aktifKosu.baslatildi_at).getTime() : Date.now();
                setGecenSure(Math.max(0, Math.floor((Date.now() - baslangicMs) / 1000)));
                stopPoll();
                timerRef.current = setInterval(() => {
                    setGecenSure(Math.floor((Date.now() - baslangicMs) / 1000));
                }, 1000);
                startPoll();
                return;
            }

            setSonuclar(null);
            setSeciliKosun(null);
            // Son tamamlananı otomatik yükle
            const son = liste.find(k => k.durum === "tamamlandi");
            if (son) {
                await sonuclariYukle(son.id);
                setSeciliKosun(son.id);
            }
        } catch (e) {
            console.error("Geçmiş yükleme hatası:", e);
        }
    };

    const aktifParamYukle = async () => {
        try {
            const token = await getToken();
            const r = await axios.get(`${API_URL}/scan/wfo/aktif-parametreler?mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAktifParam(r.data || {});
        } catch (e) {
            console.error("Aktif param yükleme hatası:", e);
        }
    };

    const rejimGecmisYukle = async () => {
        try {
            const token = await getToken();
            const r = await axios.get(`${API_URL}/scan/wfo/rejim/gecmis?mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const liste = (r.data || []).filter(k => k.mod === mod);
            setRejimGecmis(liste);
            const son = liste.find(k => k.durum === "tamamlandi");
            if (son && !rejimSonuclar) {
                await rejimSonuclariYukle(son.id);
            }
        } catch (e) {
            console.error("Rejim geçmiş yükleme hatası:", e);
        }
    };

    // ── Rejim WFO Fonksiyonları ────────────────────────────────
    const rejimSonuclariYukle = async (kid) => {
        try {
            const token = await getToken();
            const r = await axios.get(`${API_URL}/scan/wfo/rejim/sonuclar?kosun_id=${kid}&mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRejimSonuclar(r.data);
            setAktifRejim(r.data?.aktif_rejim || null);
            setRejimKosunId(kid);
        } catch (e) {
            console.error("Rejim sonuç yükleme hatası:", e);
        }
    };

    const startRejimPoll = useCallback(() => {
        if (rejimPollRef.current) { clearInterval(rejimPollRef.current); rejimPollRef.current = null; }
        rejimPollRef.current = setInterval(async () => {
            try {
                const token = await getToken();
                const r = await axios.get(`${API_URL}/scan/wfo/rejim/durum`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setRejimIlerleme(r.data.yuzde || 0);
                setRejimMsg(r.data.mesaj || "");
                if (!r.data.calisiyor) {
                    stopRejimPoll();
                    setRejimCalisiyor(false);
                    if (r.data.kosun_id) {
                        await rejimSonuclariYukle(r.data.kosun_id);
                        toast.success("WFO Rejim tamamlandı!");
                    }
                }
            } catch (e) {
                console.error("Rejim WFO polling hatası:", e);
            }
        }, 3000);
    }, [mod, stopRejimPoll]);

    const rejimWfoBaslat = async () => {
        if (rejimCalisiyor) return;
        try {
            setRejimCalisiyor(true);
            setRejimIlerleme(0);
            setRejimMsg("Başlatılıyor...");
            setRejimSonuclar(null);
            setRejimGecenSure(0);
            const t0 = Date.now();
            rejimTimerRef.current = setInterval(() => {
                setRejimGecenSure(Math.floor((Date.now() - t0) / 1000));
            }, 1000);
            const token = await getToken();
            const r = await axios.post(`${API_URL}/scan/wfo/rejim/baslat`,
                { mod, train_ay: 6, test_ay: 1 },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setRejimKosunId(r.data.kosun_id);
            startRejimPoll();
        } catch (e) {
            setRejimCalisiyor(false);
            toast.error(e.response?.data?.detail || "WFO Rejim başlatılamadı");
        }
    };

    const rejimDeployEt = async () => {
        if (deploySeciliRejim.size === 0) { toast.error("En az 1 seçim yapın"); return; }
        setDeployingRejim(true);
        try {
            const token = await getToken();
            const kid = rejimKosunId || rejimSonuclar?.kosun?.id;
            const liste = Array.from(deploySeciliRejim).map(key => {
                const [modul_adi, ...rejimParts] = key.split("/");
                return { modul_adi, rejim: rejimParts.join("/") };
            });
            await axios.post(`${API_URL}/scan/wfo/rejim/deploy`,
                { kosun_id: kid, modul_rejim_listesi: liste },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success(`${deploySeciliRejim.size} modül/rejim deploy edildi!`);
            setDeploySeciliRejim(new Set());
            setDeployModal(false);
            await rejimSonuclariYukle(kid);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Deploy başarısız");
        } finally {
            setDeployingRejim(false);
        }
    };

    const toggleRejimDeploy = (modul, rejim) => {
        const key = `${modul}/${rejim}`;
        setDeploySeciliRejim(prev => {
            const next = new Set(prev);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    };

    const sonuclariYukle = async (kid) => {
        setYukleniyor(true);
        try {
            const token = await getToken();
            const r = await axios.get(`${API_URL}/scan/wfo/sonuclar?kosun_id=${kid}&mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // aktif parametreler ayrıca aktifParamYukle() ile çekiliyor
        setSonuclar(r.data);
            setSeciliKosun(kid);
            setDeploySecili(new Set());
        } catch (e) {
            console.error("Sonuç yükleme hatası:", e);
        } finally {
            setYukleniyor(false);
        }
    };

    // ── WFO Başlat ─────────────────────────────────────────────
    const wfoBaslat = async () => {
        if (calisiyor) return;
        try {
            setCalisiyor(true);
            setIlerleme(0);
            setIlerlemeMsg("Başlatılıyor...");
            setSonuclar(null);
            setGecenSure(0);
            const t0 = Date.now();
            timerRef.current = setInterval(() => {
                setGecenSure(Math.floor((Date.now() - t0) / 1000));
            }, 1000);
            const token = await getToken();
            const r = await axios.post(`${API_URL}/scan/wfo/baslat`,
                { mod, train_ay: 6, test_ay: 1 },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setKosunId(r.data.kosun_id);
            startPoll();
        } catch (e) {
            setCalisiyor(false);
            toast.error(e.response?.data?.detail || "WFO başlatılamadı");
        }
    };

    // ── Deploy ─────────────────────────────────────────────────
    const deployEt = async () => {
        if (!kosunId && !seciliKosun) { toast.error("Koşu seçilmedi"); return; }
        if (deploySecili.size === 0) { toast.error("En az 1 modül seçin"); return; }
        setDeploying(true);
        try {
            const token = await getToken();
            const kid = kosunId || seciliKosun;
            await axios.post(`${API_URL}/scan/wfo/deploy`,
                { kosun_id: kid, modul_listesi: Array.from(deploySecili) },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success(`${deploySecili.size} modül deploy edildi!`);
            setDeploySecili(new Set());
            await aktifParamYukle();
            await sonuclariYukle(kid);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Deploy başarısız");
        } finally {
            setDeploying(false);
        }
    };

    const toggleDeploy = (modul) => {
        setDeploySecili(prev => {
            const next = new Set(prev);
            next.has(modul) ? next.delete(modul) : next.add(modul);
            return next;
        });
    };

    const tumunuSec = () => {
        if (!sonuclar?.moduller) return;
        const tumModuller = sonuclar.moduller.map(m => m.modul_adi);
        if (deploySecili.size === tumModuller.length) {
            setDeploySecili(new Set());
        } else {
            setDeploySecili(new Set(tumModuller));
        }
    };

    const formatParam = (params) => {
        if (!params || Object.keys(params).length === 0) return "–";
        return Object.entries(params).map(([k, v]) => `${k}: ${v}`).join(", ");
    };

    // ── Render ─────────────────────────────────────────────────
    return (
        <>
        <div style={{ minHeight: "100vh", width: "100%", background: C.bg }}>
        <div style={{ padding: "24px", maxWidth: 1400, margin: "0 auto", color: "#e5e7eb" }}>

            {/* Başlık */}
            <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#e5e7eb" }}>
                        🔬 Walk-Forward Optimizasyon
                    </h1>
                    <p style={{ margin: "4px 0 0", fontSize: 13, color: "#9ca3af" }}>
                        6 ay train → 1 ay test kayan pencere ile modül parametrelerini out-of-sample optimize et
                    </p>
                </div>
            </div>

            {/* Sekme Seçici */}
            <div style={{ display: "flex", gap: 4, marginBottom: 16, borderBottom: `2px solid ${C.border}`, paddingBottom: 0 }}>
                {[
                    { id: "genel",  label: "🔬 Genel WFO",         aciklama: "Tüm piyasa koşulları için optimize" },
                    { id: "rejim",  label: "🎯 Rejim-Koşullu WFO", aciklama: "Boğa/Ayı/Yatay için ayrı parametre setleri" },
                ].map(s => (
                    <button key={s.id} onClick={() => setSekme(s.id)}
                        title={s.aciklama}
                        style={{
                            padding: "10px 20px", border: "none", cursor: "pointer",
                            fontWeight: sekme === s.id ? 700 : 500, fontSize: 14,
                            background: "transparent",
                            color: sekme === s.id ? C.accent : C.muted,
                            borderBottom: sekme === s.id ? `2px solid ${C.accent}` : "2px solid transparent",
                            marginBottom: -2,
                        }}>
                        {s.label}
                    </button>
                ))}
            </div>

            {/* ── Genel WFO Sekmesi ───────────────────────────── */}
            {sekme === "genel" && (<>
            {/* Kontrol Paneli */}
            <div style={{
                background: "#1f2937", borderRadius: 10, padding: "16px 20px",
                marginBottom: 20, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap"
            }}>
                {/* Piyasa seçici */}
                <div style={{ display: "flex", gap: 8 }}>
                    {["BIST", "Kripto"].map(m => (
                        <button key={m} onClick={() => { setMod(m); setSonuclar(null); }}
                            disabled={calisiyor}
                            style={{
                                padding: "8px 18px", borderRadius: 6, border: "none",
                                cursor: calisiyor ? "not-allowed" : "pointer", fontWeight: 600, fontSize: 14,
                                background: mod === m ? "#3b82f6" : "#374151",
                                color: mod === m ? "#fff" : "#9ca3af",
                            }}>
                            {m}
                        </button>
                    ))}
                </div>

                {/* Başlat butonu */}
                <button onClick={wfoBaslat} disabled={calisiyor}
                    style={{
                        padding: "9px 22px", borderRadius: 6, border: "none",
                        background: calisiyor ? "#374151" : "#f59e0b",
                        color: calisiyor ? "#6b7280" : "#1f2937",
                        fontWeight: 700, fontSize: 14, cursor: calisiyor ? "not-allowed" : "pointer",
                    }}>
                    {calisiyor ? "⏳ Çalışıyor..." : "▶ WFO Başlat"}
                </button>

                {/* Geçmiş koşu seçici */}
                {gecmis.length > 0 && (
                    <select value={seciliKosun || ""}
                        onChange={e => e.target.value && sonuclariYukle(Number(e.target.value))}
                        disabled={calisiyor}
                        style={{
                            background: "#374151", color: "#e5e7eb", border: "1px solid #4b5563",
                            borderRadius: 6, padding: "8px 12px", fontSize: 13, cursor: "pointer"
                        }}>
                        <option value="">— Geçmiş Koşu Seç —</option>
                        {gecmis.map(k => (
                            <option key={k.id} value={k.id}>
                                #{k.id} | {k.durum === "tamamlandi" ? "✅" : k.durum === "hata" ? "❌" : "⏳"}{" "}
                                {k.baslatildi_at ? new Date(k.baslatildi_at).toLocaleDateString("tr-TR") : ""}{" "}
                                ({k.tetikleyen})
                            </option>
                        ))}
                    </select>
                )}
            </div>

            {/* İlerleme Çubuğu */}
            {calisiyor && (
                <div style={{
                    marginBottom: 16,
                    background: C.panel,
                    border: `2px solid ${C.purple}44`,
                    borderRadius: 12,
                    padding: 20,
                    boxShadow: `0 0 20px ${C.purple}22`,
                }}>
                    {/* Başlık */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                        <span style={{ fontSize: 20 }}>🔬</span>
                        <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
                            Walk-Forward Optimizasyon çalışıyor — {mod}
                        </span>
                        <span style={{ marginLeft: "auto", fontSize: 22, fontWeight: 800, color: C.purple }}>
                            %{ilerleme}
                        </span>
                    </div>
                    {/* İlerleme Çubuğu */}
                    <div style={{ height: 10, background: C.bg, borderRadius: 6, overflow: "hidden", marginBottom: 12, border: `1px solid ${C.border}` }}>
                        <div style={{
                            height: "100%", width: `${ilerleme}%`,
                            background: `linear-gradient(90deg, ${C.purple}, ${C.accent})`,
                            borderRadius: 6, transition: "width 0.6s ease",
                        }} />
                    </div>
                    {/* Mesaj */}
                    <div style={{ fontSize: 13, color: C.text, marginBottom: 14, minHeight: 20 }}>
                        {ilerlemeMsg || "İşleniyor..."}
                    </div>
                    {/* Süre Bilgileri */}
                    <div style={{ display: "flex", gap: 24 }}>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>GEÇEN SÜRE</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.teal }}>
                                {String(Math.floor(gecenSure / 60)).padStart(2,"0")}:{String(gecenSure % 60).padStart(2,"0")}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAHMİNİ KALAN</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.warning }}>
                                {ilerleme > 3
                                    ? (() => { const kalan = Math.round(gecenSure / (ilerleme / 100) - gecenSure); return `${String(Math.floor(kalan/60)).padStart(2,"0")}:${String(kalan%60).padStart(2,"0")}`; })()
                                    : "Hesaplanıyor..."}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>İLERLEME</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.accent }}>%{ilerleme}</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Yükleniyor */}
            {yukleniyor && !calisiyor && (
                <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>
                    Sonuçlar yükleniyor...
                </div>
            )}

            {/* Sonuçlar */}
            {sonuclar && !yukleniyor && (
                <>
                    {/* Koşu Özeti */}
                    {sonuclar.kosun && (
                        <div style={{
                            background: "#1f2937", borderRadius: 10, padding: "14px 20px",
                            marginBottom: 16, display: "flex", gap: 32, flexWrap: "wrap"
                        }}>
                            <div style={{ fontSize: 13, color: "#9ca3af" }}>
                                <span style={{ color: "#f9fafb", fontWeight: 600 }}>WFO #{sonuclar.kosun.id}</span>
                                <span style={{ marginLeft: 12 }}>Piyasa: <b style={{ color: "#60a5fa" }}>{sonuclar.kosun.mod}</b></span>
                                <span style={{ marginLeft: 12 }}>Pencere: <b>{sonuclar.kosun.pencere_sayisi}</b></span>
                                <span style={{ marginLeft: 12 }}>
                                    Dönem: {sonuclar.kosun.baslangic_tarihi} → {sonuclar.kosun.bitis_tarihi}
                                </span>
                                <span style={{ marginLeft: 12 }}>Tetik: {sonuclar.kosun.tetikleyen}</span>
                            </div>
                        </div>
                    )}

                    {/* Deploy Araç Çubuğu */}
                    <div style={{
                        background: "#1f2937", borderRadius: 10, padding: "12px 16px",
                        marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap"
                    }}>
                        <span style={{ fontSize: 13, color: "#9ca3af" }}>
                            {deploySecili.size} modül seçili
                        </span>
                        <button onClick={tumunuSec}
                            style={{
                                padding: "6px 14px", borderRadius: 6, border: "1px solid #4b5563",
                                background: "transparent", color: "#d1d5db", fontSize: 12,
                                cursor: "pointer"
                            }}>
                            {deploySecili.size === sonuclar.moduller?.length ? "Seçimi Kaldır" : "Tümünü Seç"}
                        </button>
                        <button onClick={deployEt}
                            disabled={deploying || deploySecili.size === 0}
                            style={{
                                padding: "7px 18px", borderRadius: 6, border: "none",
                                background: deploying || deploySecili.size === 0 ? "#374151" : "#16a34a",
                                color: deploying || deploySecili.size === 0 ? "#6b7280" : "#fff",
                                fontWeight: 700, fontSize: 13, cursor: deploying || deploySecili.size === 0 ? "not-allowed" : "pointer",
                            }}>
                            {deploying ? "Deploy ediliyor..." : `🚀 Deploy Et (${deploySecili.size})`}
                        </button>
                        <span style={{ fontSize: 12, color: "#6b7280" }}>
                            ℹ Deploy edilen parametreler production'da aktif olur
                        </span>
                    </div>

                    {/* Modül Tablosu */}
                    <div style={{ background: "#1f2937", borderRadius: 10, overflow: "visible", border: `1px solid ${C.border}` }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                            <thead>
                                <tr style={{ background: C.bg }}>
                                    <th style={{ padding: "10px 8px", textAlign: "center", width: 32 }}>
                                        <input type="checkbox"
                                            checked={sonuclar?.moduller?.length > 0 && deploySecili.size === sonuclar.moduller.length}
                                            onChange={tumunuSec}
                                            style={{ cursor: "pointer", accentColor: "#16a34a" }}
                                        />
                                    </th>
                                    <th style={{ padding: "10px 12px", textAlign: "left", color: C.muted, fontSize: 12 }}>Modül</th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Train Başarı<BilgiIkonu karti="train_basari" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Test Başarı<BilgiIkonu karti="test_basari" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Önceki<BilgiIkonu karti="onceki" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Δ<BilgiIkonu karti="delta" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Test Sharpe<BilgiIkonu karti="test_sharpe" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Sinyal<BilgiIkonu karti="sinyal" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "left", color: C.muted, fontSize: 12 }}>En İyi Parametreler</th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Deploy<BilgiIkonu karti="deploy" /></th>
                                    <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Detay</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(sonuclar.moduller || []).map((m, i) => {
                                    const d = delta(m.test_basari_orani, m.onceki_basari);
                                    const deployOldu = m.deploy_edildi;
                                    const detayAcik = detayModul === m.modul_adi;
                                    return (
                                        <React.Fragment key={m.modul_adi}>
                                        <tr
                                            style={{
                                                borderTop: "1px solid #374151",
                                                background: deploySecili.has(m.modul_adi) ? "#1e3a2f" : "transparent"
                                            }}>
                                            {/* Checkbox */}
                                            <td style={{ padding: "10px 8px", textAlign: "center" }}>
                                                <input type="checkbox"
                                                    checked={deploySecili.has(m.modul_adi)}
                                                    onChange={() => toggleDeploy(m.modul_adi)}
                                                    style={{ cursor: "pointer", accentColor: "#16a34a" }}
                                                />
                                            </td>
                                            {/* Modül adı */}
                                            <td style={{ padding: "10px 12px" }}>
                                                <span style={{ fontWeight: 600, color: "#f9fafb" }}>
                                                    {MODUL_ETIKETLER[m.modul_adi] || m.modul_adi}
                                                </span>
                                                {deployOldu && (
                                                    <span style={{
                                                        marginLeft: 6, fontSize: 10, padding: "1px 6px",
                                                        background: "#166534", color: "#86efac", borderRadius: 4
                                                    }}>AKTIF</span>
                                                )}
                                            </td>
                                            {/* Train başarı */}
                                            <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                {m.train_basari_orani !== null
                                                    ? <span style={{ color: basariRenk(m.train_basari_orani), fontWeight: 700 }}>
                                                        %{m.train_basari_orani?.toFixed(1)}
                                                    </span>
                                                    : <span style={{ color: "#6b7280" }}>–</span>}
                                            </td>
                                            {/* Test başarı */}
                                            <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                {m.test_basari_orani !== null
                                                    ? <span style={{ color: basariRenk(m.test_basari_orani), fontWeight: 700, fontSize: 15 }}>
                                                        %{m.test_basari_orani?.toFixed(1)}
                                                    </span>
                                                    : <span style={{ color: "#6b7280" }}>–</span>}
                                            </td>
                                            {/* Önceki */}
                                            <td style={{ padding: "10px 12px", textAlign: "center", color: "#9ca3af" }}>
                                                {m.onceki_basari !== null && m.onceki_basari !== undefined
                                                    ? `%${m.onceki_basari?.toFixed(1)}`
                                                    : "–"}
                                            </td>
                                            {/* Delta */}
                                            <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                <DeltaBadge val={d} />
                                            </td>
                                            {/* Test Sharpe */}
                                            <td style={{ padding: "10px 12px", textAlign: "center", color: "#d1d5db" }}>
                                                {m.test_sharpe !== null ? m.test_sharpe?.toFixed(2) : "–"}
                                            </td>
                                            {/* Sinyal sayısı */}
                                            <td style={{ padding: "10px 12px", textAlign: "center", color: "#9ca3af", fontSize: 12 }}>
                                                {m.test_sinyal_sayisi ?? "–"}
                                            </td>
                                            {/* En iyi parametreler */}
                                            <td style={{ padding: "10px 12px", maxWidth: 260 }}>
                                                <span style={{
                                                    fontSize: 11, color: "#60a5fa",
                                                    wordBreak: "break-word", lineHeight: 1.5
                                                }}>
                                                    {formatParam(m.en_iyi_params)}
                                                </span>
                                            </td>
                                            {/* Deploy checkbox işareti */}
                                            <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                {deployOldu
                                                    ? <span style={{ color: "#22c55e", fontSize: 16 }}>✓</span>
                                                    : <span style={{ color: "#374151" }}>–</span>}
                                            </td>
                                            {/* Pencere detayı */}
                                            <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                <button
                                                    onClick={() => setDetayModul(
                                                        detayModul === m.modul_adi ? null : m.modul_adi
                                                    )}
                                                    style={{
                                                        padding: "4px 10px", borderRadius: 5,
                                                        background: "#374151", border: "none",
                                                        color: "#d1d5db", fontSize: 11, cursor: "pointer"
                                                    }}>
                                                    {detayModul === m.modul_adi ? "▲ Kapat" : "▼ Pencereler"}
                                                </button>
                                            </td>
                                        </tr>
                                        {detayAcik && (
                                            <tr>
                                                <td colSpan={11} style={{ padding: 0, borderTop: "1px solid #374151" }}>
                                                    <div style={{ background: "#111827", padding: 20 }}>
                                                        <h3 style={{ margin: "0 0 14px", fontSize: 15, color: "#f9fafb" }}>
                                                            🔍 {MODUL_ETIKETLER[m.modul_adi] || m.modul_adi} — Pencere Bazlı Sonuçlar
                                                        </h3>
                                                        {!m?.pencere_detaylari?.length ? (
                                                            <p style={{ color: "#6b7280", fontSize: 13 }}>Pencere verisi bulunamadı.</p>
                                                        ) : (
                                                            <div style={{ overflowX: "auto" }}>
                                                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                                                    <thead>
                                                                        <tr style={{ color: "#9ca3af" }}>
                                                                            <th style={{ padding: "6px 12px", textAlign: "center" }}>#</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "left" }}>Train</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "left" }}>Test</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "center" }}>Train %</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "center" }}>Test %</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "center" }}>Sharpe</th>
                                                                            <th style={{ padding: "6px 12px", textAlign: "left" }}>Parametreler</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {m.pencere_detaylari.map((p, pi) => (
                                                                            <tr key={pi} style={{ borderTop: "1px solid #1f2937" }}>
                                                                                <td style={{ padding: "6px 12px", textAlign: "center", color: "#6b7280" }}>{p.pencere}</td>
                                                                                <td style={{ padding: "6px 12px", color: "#9ca3af" }}>{p.train_bas} → {p.train_bit}</td>
                                                                                <td style={{ padding: "6px 12px", color: "#9ca3af" }}>{p.test_bas} → {p.test_bit}</td>
                                                                                <td style={{ padding: "6px 12px", textAlign: "center" }}>
                                                                                    <span style={{ color: basariRenk(p.train_basari), fontWeight: 600 }}>
                                                                                        {p.train_basari !== null ? `%${p.train_basari?.toFixed(1)}` : "–"}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{ padding: "6px 12px", textAlign: "center" }}>
                                                                                    <span style={{ color: basariRenk(p.test_basari), fontWeight: 700 }}>
                                                                                        {p.test_basari !== null ? `%${p.test_basari?.toFixed(1)}` : "–"}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{ padding: "6px 12px", textAlign: "center", color: "#d1d5db" }}>
                                                                                    {p.test_sharpe !== null ? p.test_sharpe?.toFixed(2) : "–"}
                                                                                </td>
                                                                                <td style={{ padding: "6px 12px" }}>
                                                                                    <span style={{ fontSize: 11, color: "#60a5fa" }}>
                                                                                        {formatParam(p.params)}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>


                    {/* Aktif Parametreler Özeti */}
                    {Object.keys(aktifParam).length > 0 && (
                        <div style={{
                            background: "#1f2937", borderRadius: 10, padding: "16px 20px",
                            marginTop: 20
                        }}>
                            <h3 style={{ margin: "0 0 12px", fontSize: 15, color: "#f9fafb" }}>
                                ✅ Şu An Aktif Parametreler ({mod})
                            </h3>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                {Object.entries(aktifParam).map(([modul, info]) => (
                                    <div key={modul} style={{
                                        background: "#111827", borderRadius: 8, padding: "8px 14px",
                                        border: "1px solid #374151", minWidth: 160
                                    }}>
                                        <div style={{ fontWeight: 600, fontSize: 12, color: "#60a5fa", marginBottom: 4 }}>
                                            {MODUL_ETIKETLER[modul] || modul}
                                        </div>
                                        <div style={{ fontSize: 11, color: "#9ca3af" }}>
                                            {formatParam(info.parametreler) || "Varsayılan"}
                                        </div>
                                        {info.basari_orani && (
                                            <div style={{ fontSize: 11, color: basariRenk(info.basari_orani), marginTop: 3, fontWeight: 600 }}>
                                                %{info.basari_orani?.toFixed(1)} başarı
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* Boş durum */}
            {!sonuclar && !calisiyor && !yukleniyor && (
                <div style={{
                    background: "#1f2937", borderRadius: 10, padding: 48,
                    textAlign: "center", color: "#6b7280"
                }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>🔬</div>
                    <div style={{ fontSize: 16, color: "#9ca3af", marginBottom: 8 }}>
                        Henüz WFO çalıştırılmamış
                    </div>
                    <div style={{ fontSize: 13 }}>
                        "WFO Başlat" butonuna basarak optimizasyonu başlatın.
                        <br />Pazar geceleri otomatik çalışır.
                    </div>
                </div>
            )}
            </>)}

            {/* ── Rejim-Koşullu WFO Sekmesi ──────────────────── */}
            {sekme === "rejim" && (
                <RejimWfoPanel
                    mod={mod}
                    calisiyor={rejimCalisiyor}
                    ilerleme={rejimIlerleme}
                    ilerlemeMsg={rejimMsg}
                    gecenSure={rejimGecenSure}
                    sonuclar={rejimSonuclar}
                    aktifRejim={aktifRejim}
                    secilenRejimTab={secilenRejimTab}
                    setSecilenRejimTab={setSecilenRejimTab}
                    deployModal={deployModal}
                    setDeployModal={setDeployModal}
                    deploySecili={deploySeciliRejim}
                    toggleDeploy={toggleRejimDeploy}
                    deployEt={rejimDeployEt}
                    deploying={deployingRejim}
                    onBaslat={rejimWfoBaslat}
                    formatParam={formatParam}
                    basariRenk={basariRenk}
                    C={C}
                    gecmis={rejimGecmis}
                    seciliKosun={rejimKosunId}
                    onGecmisSecim={async (kid) => {
                        await rejimSonuclariYukle(kid);
                    }}
                />
            )}
        </div>
        </div>
        </>
    );
}

// ─────────────────────────────────────────────────────────────────
// RejimWfoPanel bileşeni
// ─────────────────────────────────────────────────────────────────

const REJIMLER = ["Güçlü Boğa", "Boğa", "Yatay", "Ayı", "Güçlü Ayı"];

const REJiM_RENK = {
    "Güçlü Boğa": "#16a34a",
    "Boğa":        "#22c55e",
    "Yatay":       "#f59e0b",
    "Ayı":         "#ef4444",
    "Güçlü Ayı":   "#dc2626",
};

const REJiM_EMOJI = {
    "Güçlü Boğa": "🚀",
    "Boğa":        "📈",
    "Yatay":       "↔️",
    "Ayı":         "📉",
    "Güçlü Ayı":   "💥",
};

function RejimWfoPanel({
    mod, calisiyor, ilerleme, ilerlemeMsg, gecenSure,
    sonuclar, aktifRejim, secilenRejimTab, setSecilenRejimTab,
    deployModal, setDeployModal, deploySecili, toggleDeploy,
    deployEt, deploying, onBaslat, formatParam, basariRenk, C,
    gecmis, onGecmisSecim, seciliKosun
}) {
    const formatSure = (s) => `${String(Math.floor(s/60)).padStart(2,"0")}:${String(s%60).padStart(2,"0")}`;

    const rejimModuller = sonuclar?.rejimler?.[secilenRejimTab] || [];
    const yeterliModuller = rejimModuller.filter(m => m.yeterli_veri);
    const yetersizModuller = rejimModuller.filter(m => !m.yeterli_veri);

    return (
        <div>
            {/* Kontrol */}
            <div style={{
                background: C.panel, borderRadius: 10, padding: "16px 20px",
                marginBottom: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap"
            }}>
                <button onClick={onBaslat} disabled={calisiyor}
                    style={{
                        padding: "9px 22px", borderRadius: 6, border: "none",
                        background: calisiyor ? "#374151" : "#7c3aed",
                        color: calisiyor ? "#6b7280" : "#fff",
                        fontWeight: 700, fontSize: 14, cursor: calisiyor ? "not-allowed" : "pointer",
                    }}>
                    {calisiyor ? "⏳ Çalışıyor..." : "🎯 Rejim WFO Başlat"}
                </button>
                {aktifRejim && (
                    <div style={{
                        padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 700,
                        background: `${REJiM_RENK[aktifRejim] || "#374151"}22`,
                        border: `1px solid ${REJiM_RENK[aktifRejim] || "#374151"}`,
                        color: REJiM_RENK[aktifRejim] || "#e5e7eb",
                    }}>
                        {REJiM_EMOJI[aktifRejim]} Aktif Rejim: {aktifRejim}
                    </div>
                )}
                {gecmis?.length > 0 && (
                    <select value={seciliKosun || ""}
                        onChange={e => e.target.value && onGecmisSecim(Number(e.target.value))}
                        disabled={calisiyor}
                        style={{
                            background: "#374151", color: "#e5e7eb", border: "1px solid #4b5563",
                            borderRadius: 6, padding: "8px 12px", fontSize: 13, cursor: "pointer"
                        }}>
                        <option value="">— Geçmiş WFO Seç —</option>
                        {gecmis.map(k => (
                            <option key={k.id} value={k.id}>
                                #{k.id} | {k.durum === "tamamlandi" ? "✅" : k.durum === "hata" ? "❌" : "⏳"}{" "}
                                {k.baslatildi_at ? new Date(k.baslatildi_at).toLocaleDateString("tr-TR") : ""}{" "}
                                ({k.tetikleyen})
                            </option>
                        ))}
                    </select>
                )}
                <span style={{ fontSize: 12, color: C.muted, marginLeft: "auto" }}>
                    Her rejim için ayrı parametre seti optimize edilir
                </span>
            </div>

            {/* İlerleme */}
            {calisiyor && (
                <div style={{
                    marginBottom: 16, background: C.panel,
                    border: `2px solid #7c3aed44`, borderRadius: 12, padding: 20,
                    boxShadow: "0 0 20px #7c3aed22",
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                        <span style={{ fontSize: 20 }}>🎯</span>
                        <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
                            Rejim WFO çalışıyor — {mod}
                        </span>
                        <span style={{ marginLeft: "auto", fontSize: 22, fontWeight: 800, color: "#7c3aed" }}>
                            %{ilerleme}
                        </span>
                    </div>
                    <div style={{ height: 10, background: C.bg, borderRadius: 6, overflow: "hidden", marginBottom: 12, border: `1px solid ${C.border}` }}>
                        <div style={{
                            height: "100%", width: `${ilerleme}%`,
                            background: "linear-gradient(90deg, #7c3aed, #a855f7)",
                            borderRadius: 6, transition: "width 0.6s ease",
                        }} />
                    </div>
                    <div style={{ fontSize: 13, color: C.text, marginBottom: 14 }}>{ilerlemeMsg}</div>
                    <div style={{ display: "flex", gap: 24 }}>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>GEÇEN SÜRE</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.teal }}>{formatSure(gecenSure)}</div>
                        </div>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAHMİNİ KALAN</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: C.warning }}>
                                {ilerleme > 3
                                    ? formatSure(Math.max(0, Math.round(gecenSure / (ilerleme / 100) - gecenSure)))
                                    : "Hesaplanıyor..."}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>MODÜL × REJİM</div>
                            <div style={{ fontSize: 16, fontWeight: 700, color: "#a855f7" }}>19 × 5 = 95</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Boş durum */}
            {!sonuclar && !calisiyor && (
                <div style={{
                    background: C.panel, borderRadius: 10, padding: 48,
                    textAlign: "center", color: C.muted
                }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>🎯</div>
                    <div style={{ fontSize: 16, color: C.text, marginBottom: 8 }}>
                        Rejim-Koşullu WFO henüz çalıştırılmamış
                    </div>
                    <div style={{ fontSize: 13 }}>
                        Her rejim (Güçlü Boğa → Güçlü Ayı) için ayrı parametre seti optimize edilir.
                        <br />Boğa piyasasındaki en iyi parametreler ayı piyasasında otomatik devreye girer.
                    </div>
                </div>
            )}

            {/* Sonuçlar */}
            {sonuclar && !calisiyor && (
                <>
                    {/* Rejim tab'ları */}
                    <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap" }}>
                        {REJIMLER.map(r => {
                            const moduller = sonuclar.rejimler?.[r] || [];
                            const yeterli  = moduller.filter(m => m.yeterli_veri).length;
                            const toplam   = moduller.length;
                            const isAktif  = r === aktifRejim;
                            return (
                                <button key={r} onClick={() => setSecilenRejimTab(r)}
                                    style={{
                                        padding: "8px 16px", borderRadius: 8, border: `1px solid`,
                                        borderColor: secilenRejimTab === r ? REJiM_RENK[r] : C.border,
                                        background: secilenRejimTab === r ? `${REJiM_RENK[r]}22` : C.panel,
                                        color: secilenRejimTab === r ? REJiM_RENK[r] : C.muted,
                                        fontWeight: secilenRejimTab === r ? 700 : 500,
                                        fontSize: 13, cursor: "pointer",
                                        position: "relative",
                                    }}>
                                    {REJiM_EMOJI[r]} {r}
                                    <span style={{ marginLeft: 6, fontSize: 11, opacity: 0.8 }}>
                                        {yeterli}/{toplam}
                                    </span>
                                    {isAktif && (
                                        <span style={{
                                            position: "absolute", top: -6, right: -6,
                                            background: REJiM_RENK[r], color: "#fff",
                                            fontSize: 9, padding: "1px 4px", borderRadius: 4, fontWeight: 700,
                                        }}>AKTİF</span>
                                    )}
                                </button>
                            );
                        })}

                        {/* Deploy butonu */}
                        <button onClick={() => setDeployModal(true)}
                            disabled={deploySecili.size === 0}
                            style={{
                                marginLeft: "auto", padding: "8px 18px", borderRadius: 8,
                                border: "none", fontWeight: 700, fontSize: 13,
                                background: deploySecili.size > 0 ? "#16a34a" : "#374151",
                                color: deploySecili.size > 0 ? "#fff" : "#6b7280",
                                cursor: deploySecili.size > 0 ? "pointer" : "not-allowed",
                            }}>
                            🚀 Deploy Et ({deploySecili.size})
                        </button>
                    </div>

                    {/* Yeterli veri olan modüller tablosu */}
                    {yeterliModuller.length > 0 && (
                        <div style={{ background: C.panel, borderRadius: 10, overflow: "hidden", marginBottom: 12 }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                <thead>
                                    <tr style={{ background: C.bg }}>
                                        <th style={{ padding: "10px 8px", width: 32, textAlign: "center" }}>
                                            <input type="checkbox"
                                                checked={yeterliModuller.every(m => deploySecili.has(`${m.modul_adi}/${secilenRejimTab}`))}
                                                onChange={() => {
                                                    const tumKey = yeterliModuller.map(m => `${m.modul_adi}/${secilenRejimTab}`);
                                                    tumKey.forEach(k => {
                                                        const [md, ...rp] = k.split("/");
                                                        toggleDeploy(md, rp.join("/"));
                                                    });
                                                }}
                                                style={{ cursor: "pointer", accentColor: "#16a34a" }}
                                            />
                                        </th>
                                        <th style={{ padding: "10px 12px", textAlign: "left", color: C.muted, fontSize: 12 }}>Modül</th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Train %<BilgiIkonu karti="train_basari" /></th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Test %<BilgiIkonu karti="test_basari" /></th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Δ<BilgiIkonu karti="delta" /></th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Sharpe<BilgiIkonu karti="test_sharpe" /></th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Sinyal<BilgiIkonu karti="sinyal" /></th>
                                        <th style={{ padding: "10px 12px", textAlign: "left", color: C.muted, fontSize: 12 }}>Parametreler</th>
                                        <th style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>Deploy<BilgiIkonu karti="deploy" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {yeterliModuller.map(m => {
                                        const key = `${m.modul_adi}/${secilenRejimTab}`;
                                        const d = m.test_basari_orani && m.onceki_basari
                                            ? Math.round((m.test_basari_orani - m.onceki_basari) * 10) / 10
                                            : null;
                                        return (
                                            <tr key={m.modul_adi}
                                                style={{ borderTop: `1px solid ${C.border}`, background: deploySecili.has(key) ? "#1e3a2f" : "transparent" }}>
                                                <td style={{ padding: "10px 8px", textAlign: "center" }}>
                                                    <input type="checkbox"
                                                        checked={deploySecili.has(key)}
                                                        onChange={() => toggleDeploy(m.modul_adi, secilenRejimTab)}
                                                        style={{ cursor: "pointer", accentColor: "#16a34a" }}
                                                    />
                                                </td>
                                                <td style={{ padding: "10px 12px", fontWeight: 600, color: C.text }}>
                                                    {MODUL_ETIKETLER[m.modul_adi] || m.modul_adi}
                                                    {m.deploy_edildi && <span style={{ marginLeft: 6, fontSize: 10, padding: "1px 5px", background: "#166534", color: "#86efac", borderRadius: 4 }}>AKTİF</span>}
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                    <span style={{ color: basariRenk(m.train_basari_orani), fontWeight: 600 }}>
                                                        {m.train_basari_orani != null ? `%${m.train_basari_orani.toFixed(1)}` : "–"}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                    <span style={{ color: basariRenk(m.test_basari_orani), fontWeight: 700, fontSize: 15 }}>
                                                        {m.test_basari_orani != null ? `%${m.test_basari_orani.toFixed(1)}` : "–"}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                    {d !== null
                                                        ? <span style={{ color: d > 0 ? "#22c55e" : d < 0 ? "#ef4444" : "#9ca3af", fontSize: 11, fontWeight: 600 }}>
                                                            {d > 0 ? "▲" : d < 0 ? "▼" : "–"}{Math.abs(d).toFixed(1)}%
                                                        </span>
                                                        : <span style={{ color: C.muted }}>–</span>}
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center", color: C.text }}>
                                                    {m.test_sharpe != null ? m.test_sharpe.toFixed(2) : "–"}
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center", color: C.muted, fontSize: 12 }}>
                                                    {m.test_sinyal_sayisi ?? "–"}
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <span style={{ fontSize: 11, color: "#60a5fa" }}>{formatParam(m.en_iyi_params)}</span>
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                    {m.deploy_edildi ? <span style={{ color: "#22c55e", fontSize: 16 }}>✓</span> : <span style={{ color: C.border }}>–</span>}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Yetersiz veri uyarısı */}
                    {yetersizModuller.length > 0 && (
                        <div style={{ background: `${C.warning}11`, border: `1px solid ${C.warning}44`, borderRadius: 8, padding: "12px 16px" }}>
                            <span style={{ fontSize: 12, color: C.warning, fontWeight: 600 }}>
                                ⚠️ {yetersizModuller.length} modül yetersiz veri: {yetersizModuller.map(m => MODUL_ETIKETLER[m.modul_adi] || m.modul_adi).join(", ")}
                            </span>
                            <span style={{ fontSize: 11, color: C.muted, marginLeft: 8 }}>
                                (Min 10 sinyal gerekli, veri birikmesiyle optimize edilecek)
                            </span>
                        </div>
                    )}
                </>
            )}

            {/* Deploy Modal */}
            {deployModal && (
                <div style={{
                    position: "fixed", inset: 0, zIndex: 1000,
                    background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center"
                }} onClick={() => setDeployModal(false)}>
                    <div style={{
                        background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                        padding: 28, maxWidth: 480, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.5)"
                    }} onClick={e => e.stopPropagation()}>
                        <h3 style={{ margin: "0 0 8px", color: C.text, fontSize: 17 }}>🚀 Deploy Onayı</h3>
                        {aktifRejim && (
                            <div style={{
                                marginBottom: 16, padding: "10px 14px", borderRadius: 8,
                                background: `${REJiM_RENK[aktifRejim] || "#374151"}22`,
                                border: `1px solid ${REJiM_RENK[aktifRejim] || "#374151"}`,
                                color: REJiM_RENK[aktifRejim] || C.text, fontSize: 13, fontWeight: 600,
                            }}>
                                {REJiM_EMOJI[aktifRejim]} Mevcut piyasa rejimi: <b>{aktifRejim}</b>
                                <div style={{ fontSize: 11, fontWeight: 400, color: C.muted, marginTop: 4 }}>
                                    Deploy edilen parametreler production'da aktif olur.
                                    Taramalar mevcut rejime göre otomatik parametre seti kullanır.
                                </div>
                            </div>
                        )}
                        <p style={{ color: C.muted, fontSize: 13, marginBottom: 16 }}>
                            <b style={{ color: C.text }}>{deploySecili.size}</b> modül/rejim kombinasyonu deploy edilecek:
                        </p>
                        <div style={{ marginBottom: 20, maxHeight: 180, overflowY: "auto" }}>
                            {Array.from(deploySecili).map(key => {
                                const [md, ...rp] = key.split("/");
                                const r = rp.join("/");
                                return (
                                    <div key={key} style={{
                                        display: "flex", justifyContent: "space-between", alignItems: "center",
                                        padding: "6px 10px", marginBottom: 4, borderRadius: 6,
                                        background: C.bg, fontSize: 12,
                                    }}>
                                        <span style={{ color: C.text }}>{MODUL_ETIKETLER[md] || md}</span>
                                        <span style={{ color: REJiM_RENK[r] || C.muted, fontWeight: 600, fontSize: 11 }}>
                                            {REJiM_EMOJI[r]} {r}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                            <button onClick={() => setDeployModal(false)}
                                style={{ padding: "9px 18px", borderRadius: 8, border: `1px solid ${C.border}`, background: "transparent", color: C.muted, cursor: "pointer" }}>
                                İptal
                            </button>
                            <button onClick={deployEt} disabled={deploying}
                                style={{ padding: "9px 20px", borderRadius: 8, border: "none", fontWeight: 700,
                                    background: deploying ? "#374151" : "#16a34a", color: deploying ? C.muted : "#fff", cursor: deploying ? "not-allowed" : "pointer" }}>
                                {deploying ? "Deploy ediliyor..." : "✓ Onayla ve Deploy Et"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
